import NavBar from "../../../components/organisms/navbar";
import { Content, PaymentContainer } from "../styles";
import { useParams } from "react-router-dom";
import Confetti from "react-confetti";
import { useEffect, useState } from "react";

const PaymentEnrollmentICopaEuAmoParintinsDeJiuJitsu2025 = () => {
    const { slug, id } = useParams();
    console.log(slug);

    // Estados para controlar os confetes
    const [windowSize, setWindowSize] = useState({ width: window.innerWidth, height: window.innerHeight });
    const [confettiPieces, setConfettiPieces] = useState(300); // Inicia com 300 confetes

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({ width: window.innerWidth, height: window.innerHeight });
        };
        window.addEventListener("resize", handleResize);

        // 💥 Reduzindo os confetes suavemente para que terminem de cair sem corte
        const interval = setInterval(() => {
            setConfettiPieces((prev) => {
                if (prev <= 0) {
                    clearInterval(interval); // 🔴 Para o intervalo quando os confetes chegam a 0
                    return 0;
                }
                return prev - 15; // Diminui a quantidade aos poucos
            });
        }, 300); // Redução gradual a cada 300ms

        return () => {
            window.removeEventListener("resize", handleResize);
            clearInterval(interval); // Garante que o intervalo não continue rodando ao desmontar o componente
        };
    }, []);

    return (
        <div>
            <NavBar />
            {confettiPieces > 0 && (
                <Confetti width={windowSize.width} height={windowSize.height} numberOfPieces={confettiPieces} />
            )}
            <Content>
                <PaymentContainer>
                    <div style={{ textAlign: "center", padding: "20px" }}>
                        <h1 style={{ color: "#28a745", fontSize: "2rem" }}>🎉 Inscrição Confirmada! 🎉</h1>
                        <h2 style={{ textAlign: "center" }}>
                            Obrigado por se inscrever na: <br />
                            {"I COPA EU AMO PARINTINS DE JIU JITSU"}
                        </h2>
                        <h2 style={{ color: "red" }}>Inscrição N° {id}</h2>
                        {/* <p style={{ fontSize: "1.5rem", marginTop: "10px" }}>😃 Seu pagamento será atualizado automaticamente.</p> */}
                        <h1>Instruções:</h1>
                        <h3>
                            1° Acompanhe o status da sua inscrição em: <br />
                            <a href="/profile/subscription">Minhas Inscrições</a>{" "}
                        </h3>
                        <h3>
                            2° Fique atento ao edital para não ser desclassificado. 📜
                        </h3>
                    </div>
                </PaymentContainer>
            </Content>
        </div>
    );
}

export default PaymentEnrollmentICopaEuAmoParintinsDeJiuJitsu2025;